<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="font-weight-3">
        <MyCheckbox
          v-model="form['showInLoop']"
          text="questions.setting.showInLoop"
      /></v-col>
      <v-col cols="12" class="font-weight-3">
        <MyCheckbox
          v-model="form['fullscreen']"
          text="questions.setting.fullscreen"
      /></v-col>
      <v-col cols="12"><v-divider /></v-col>
      <v-col cols="12">
        <MyRadio
          v-model="form['skipAfterClick']"
          text="questions.setting.skipAfterClick"
        />
      </v-col>
      <v-col cols="12">
        <MyRadio
          v-model="form.automaticSkip.active"
          text="questions.setting.automaticSkip"
        >
          <validation-provider
            v-if="form.automaticSkip.active"
            rules="required"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="form.automaticSkip.seconds"
              type="number"
              dense
              :error-messages="errors"
              required
              hide-details
              hide-spin-buttons
              autofocus
            />
            <span v-if="errors[0]" class="pink--text text-caption">
              {{ $t('errors.notEmpty') }}
            </span>
          </validation-provider>
          <v-text-field v-else disabled dense hide-details hide-spin-buttons />
        </MyRadio>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import MyCheckbox from '@/components/MyCheckbox.vue'
import MyRadio from '@/components/MyRadio.vue'
import { mediaStructure } from '@/data/data structure'
export default {
  name: 'MediaSetting',
  components: {
    MyCheckbox,
    MyRadio,
  },
  props: {
    value: Object,
    invalid: Boolean,
  },
  data() {
    return {
      names: ['skipAfterClick', 'automaticSkip.active'],
      oldSeconds: '',
    }
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  mounted() {
    this.form = {
      ...mediaStructure.setting,
      ...this.form,
      skipAfterClick: !this.form?.automaticSkip?.active ? true : false,
    }
  },
  watch: {
    'form.skipAfterClick'() {
      if (this.form.skipAfterClick) {
        this.form.automaticSkip.active = false
        this.oldSeconds = this.form.automaticSkip.seconds
        this.form.automaticSkip.seconds = ''
      }
    },
    'form.automaticSkip.active'() {
      if (this.form.automaticSkip.active) {
        this.form.skipAfterClick = false
        this.form.automaticSkip.seconds = this.oldSeconds
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
